export class MissingSubscriptionForCertificateExportError extends Error {
  constructor() {
    super('No subscription is selected for the current user');
    this.name = 'MissingSubscriptionForCertificateExportError';
  }
}
